import React, { useContext } from 'react';
import Menu from '@mui/material/Menu';
import Badge from '@mui/material/Badge';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
// import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { EventUpcoming, EventBusy } from '../../../SvgIcons/SvgIcons';
import LogoutIcon from '@mui/icons-material/Logout';
import NavFooter from './NavFooter';
import { Button, createTheme, Grid } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/NotificationsNone';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


import { ThemeProvider } from '@mui/material';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Avatar } from '@mui/material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
// import UpcomingOutlinedIcon from '@mui/icons-material/UpcomingOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
// import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
import { Stack } from '@mui/material';
import { VectorMenu } from '../../../SvgIcons/SvgIcons';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { OpenSwal, notistackSnakebar } from '../../../Utils';
import LinearProgress from '@mui/material/LinearProgress';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { url_get_bell_notification_messages, url_store_datas } from '../../../RoutesMap';
import { ScrollTypography } from '../../../Styles';
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { apiWithAuth } from '../../../Services/Axios/axios';
import { AuthContext } from '../../../Context/AuthProvider';
import { signOut } from 'aws-amplify/auth';

const drawerWidth = 300;
const sidemenuList = [{ menu_name: 'Dashboard', menu_path: 'Dashboard', menu_icon: <DashboardOutlinedIcon />, menu_status: true },
{ menu_name: 'New Assignment Request', menu_path: 'NewAssignment_list', menu_icon: <DriveFileMoveOutlinedIcon />, menu_status: true },
{ menu_name: 'Upcoming Assignments', menu_path: 'Upcoming_list', menu_icon: <EventUpcoming color='white' size="1.6em" />, menu_status: true },
{ menu_name: 'Active Assignments', menu_path: 'Active_list', menu_icon: <PlayCircleFilledWhiteOutlinedIcon />, menu_status: true },
{ menu_name: "Action Pending", menu_path: 'Action_list', menu_icon: <DriveFolderUploadOutlinedIcon />, menu_status: true },
{ menu_name: 'Completed Assignments', menu_path: 'Completed_list', menu_icon: <FactCheckOutlinedIcon />, menu_status: true },
{ menu_name: 'Cancelled Assignments', menu_path: 'Cancelled_list', menu_icon: <EventBusy color='white' size="1.6em" />, menu_status: true },
{ menu_name: 'Withdrawn Assignments', menu_path: 'Withdrawn_list', menu_icon: <RemoveCircleOutlineIcon color='white' size="1.6em" />, menu_status: true },
{ menu_name: 'Raise Invoice', menu_path: 'Raise_invoice', menu_icon: <ReceiptOutlinedIcon />, menu_status: true },
{ menu_name: 'Invoice History', menu_path: 'Invoicehistory_list', menu_icon: <HistoryOutlinedIcon />, menu_status: true },
{ menu_name: 'Settings', menu_path: 'App_Setting', menu_icon: <SettingsSuggestOutlinedIcon />, menu_status: true },
{ menu_name: 'Support', menu_path: 'App_support', menu_icon: <SupportAgentOutlinedIcon />, menu_status: true },
{ menu_name: 'About', menu_path: 'About_page', menu_icon: <InfoOutlinedIcon />, menu_status: true },
];




const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));
document.body.style = 'background: #f2f2f2';


function NotificationListComp(props) {

    return (<Box>
        <ListItem  >
            <ListItemAvatar>
                <Avatar></Avatar>
            </ListItemAvatar>
            <ListItemText disableTypography={true}
                primary={<Typography fontWeight="bold" variant='subtitle1'>{props.heading}</Typography>}
                secondary={null}
            />
        </ListItem>
        <Box ml={2}>
            <Typography variant='subtitle1'>{props.body}</Typography>
            <Box sx={{ mt: 0.3 }}>
                {props.subtitle.subtitle_heading && <Stack direction='row' spacing={0.5}><Typography color="black" variant='subtitle2' fontWeight='bold' >{props.subtitle.subtitle_heading}:</Typography> <Typography variant='subtitle2' fontWeight="normal">{props.subtitle.subtitle_value}</Typography></Stack>}
                <Stack direction='row' spacing={0.5}><Typography color="black" variant='subtitle2' fontWeight='bold'>Added Date: </Typography> <Typography variant='subtitle2' fontWeight="normal">{props.addedDate}</Typography></Stack>
            </Box>
        </Box>
        <Divider variant="middle" />
    </Box>);
}

export default function HeaderWithSidemenu({ PusherDashboardTrigger }) {
    const { currentUser } = useContext(AuthContext);
    const theme = useTheme();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [NotificationListAry, NotificationListArySet] = React.useState([]);
    const [NotiFicationCountNumber, NotiFicationCountNumberSet] = React.useState(0);
    const [LinearProgressBarLoading, LinearProgressBarLoadingSet] = React.useState(false);
    const [ClearAllNotificationButtonLoading, ClearAllNotificationButtonLoadingSet] = React.useState(false);
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    let iti_user_full_name = currentUser['custom:first_name'] + ' ' + currentUser['custom:last_name'];

    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const SetHeaderNameAppbar = (menuname, path) => {
        setOpen(false);
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleMenu = (event) => {
        LinearProgressBarLoadingSet(true);
        LoadNotificationList('new', event.currentTarget);
        // console.log(event.currentTarget)
    };
    React.useEffect(() => {
        LoadNotificationList('count', '');
    }, [PusherDashboardTrigger]);


    // console.log(trigger)

    const LoadNotificationList = async (status, targetval) => {

        let assign_data = { status: status }
        await apiWithAuth.post(url_get_bell_notification_messages, assign_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                if (status === 'count') NotiFicationCountNumberSet(response.data.count);
                else if (status === 'new') {
                    LinearProgressBarLoadingSet(false);
                    NotificationListArySet(response.data.data);
                    if (targetval !== "") setAnchorEl(targetval);
                }
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else {
                LinearProgressBarLoadingSet(false);
                OpenSwal('Axios_error', response.data.message);
            }
        });
    }


    const ClearAllNotifications = () => {
        ClearAllNotificationButtonLoadingSet(true);
        let assign_data = { status: 'clear_all_notifications' }
        apiWithAuth.post(url_store_datas, assign_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                ClearAllNotificationButtonLoadingSet(false);
                NotiFicationCountNumberSet(0);
                handleClose();
                notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: 'All Notication Cleared', variant: 'success' });
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else {
                OpenSwal('Axios_error', response.data.message);
            }
        });
    }

    const ViewAllNotifications = () => {
        navigate('/Interpreter/Notification_list');
        handleClose();
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const SessionLogout = async () => {
        sessionStorage.clear();
        await signOut({ global: true });
        navigate('/login');
    }

    const ProfileViewNavigate = () => {
        setOpen(false)
        navigate('/Interpreter/Profile_view');
    };

    const AppBarTheme = createTheme({  //grey light theme
        palette: {
            primary: {
                light: '#f2f2f2',
                main: '#f2f2f2',
                dark: '#f2f2f2',
                contrastText: '#03070f',
            },

        }, backgroundColor: '#d7d7d7'
    });
    const SideDrawerTheme = createTheme({  //green dark
        palette: {
            primary: {
                light: '#f2f2f2',
                main: '#89B601',
                dark: '#0a1224',
                contrastText: '#03070f',
            },
            backgroundColor: "#89B601",
            backgroundColorSelected: "#6c8f03",
            text: {
                primary: "#03070f"
            },
            drawerTextColor: 'white'

        },
    });

    return (

        <Box >


            <ClickAwayListener onClickAway={() => setOpen(false)} >
                <Box>
                    <ThemeProvider theme={AppBarTheme}>
                        <MuiAppBar position="fixed" open={open} sx={{ backgroundColor: AppBarTheme.backgroundColor, zIndex: 3 }} >
                            <Toolbar>
                                <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerOpen} edge="start" sx={{ mr: 0.5, ...(open && { display: 'none' }) }} > <VectorMenu size="1.2em" color="#4c4c4c" /> </IconButton>
                                <Box sx={{ flexGrow: 1 }}>
                                    {!open && <Typography color={appThemeColor} style={{ fontWeight: 'bold' }} sx={{ typography: { xs: 'subtitle1', md: 'h6' } }}> ITI Live </Typography>}
                                </Box>
                                <IconButton aria-controls="menu-appbar" size="large" aria-haspopup="true" onClick={handleMenu} >
                                    <Badge badgeContent={NotiFicationCountNumber} showZero={false} color={appThemeSecondaryColor}>
                                        <NotificationsIcon />
                                    </Badge>
                                </IconButton>
                                <Menu anchorEl={anchorEl} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right', }} open={Boolean(anchorEl)} onClose={handleClose} >
                                    <Box >
                                        <Box>
                                            <Stack direction='row'>
                                                <Typography sx={{ flexGrow: 1, }} variant='h6' fontWeight='bold' color={appThemeSecondaryColor}>  <IconButton sx={{ pointerEvents: 'none', mr: -1, mt: -0.4 }}><NotificationsIcon color={appThemeSecondaryColor} sx={{ fontSize: 25 }} /></IconButton>New Notifications</Typography>
                                                <IconButton onClick={handleClose}>
                                                    <CloseIcon />
                                                </IconButton>
                                            </Stack>
                                        </Box>
                                        {(NotificationListAry.length === 0) ? <Box  >
                                            <Box sx={{ pt: 5, pb: 5, backgroundColor: '#fbfbfb' }}>
                                                <Typography color='error' align='center'>No New Notifications!</Typography>
                                            </Box>
                                        </Box> : <Box sx={{ height: 300, overflow: 'auto', backgroundColor: '#fbfbfb' }}>
                                            <List >
                                                {NotificationListAry.map((data, key) => {
                                                    return (<NotificationListComp key={key} heading={data.header_name} body={data.notification_message} subtitle={data.subtitle_array} addedDate={data.added_date_user} />)
                                                })}
                                            </List>
                                        </Box>}
                                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                            <Button color={appThemeSecondaryColor} startIcon={<VisibilityOutlinedIcon />} sx={{ textTransform: 'none' }} onClick={ViewAllNotifications}>View All</Button>
                                            <LoadingButton color='error' startIcon={<CloseIcon />} loadingPosition='start' disabled={(NotificationListAry.length === 0) ? true : false} loading={ClearAllNotificationButtonLoading} sx={{ textTransform: 'none' }} onClick={ClearAllNotifications}>Clear All</LoadingButton>
                                        </Box>
                                    </Box>
                                </Menu>
                            </Toolbar>
                            {LinearProgressBarLoading && <LinearProgress color={appThemeSecondaryColor} />}
                        </MuiAppBar>
                    </ThemeProvider>
                    <ThemeProvider theme={SideDrawerTheme}>
                        <Drawer sx={{ width: drawerWidth, flexShrink: 0, '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box', backgroundColor: SideDrawerTheme.palette.backgroundColor, borderEndEndRadius: '10px', borderTopRightRadius: '10px' }, }} variant="persistent" anchor="left" open={open}    >
                            <DrawerHeader  >

                                <Grid container spacing={1}>
                                    <Grid item xs={0.5}  >

                                    </Grid>
                                    <Grid item xs={2}  >
                                        <Box sx={{ cursor: 'pointer' }} onClick={ProfileViewNavigate}>
                                            <Avatar alt={iti_user_full_name} src={currentUser['profile_image']} />
                                        </Box>

                                    </Grid>
                                    <Grid item xs={7.5} display='flex' alignItems='center'>
                                        <Box sx={ScrollTypography} >
                                            <Typography color={SideDrawerTheme.palette.drawerTextColor}>{iti_user_full_name}</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={2}>
                                        <IconButton sx={{ color: SideDrawerTheme.palette.drawerTextColor }} onClick={handleDrawerClose}>
                                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                                        </IconButton>
                                    </Grid>
                                </Grid>


                            </DrawerHeader>
                            <Divider />
                            {/* <List  dense={true}>   inline gap */}
                            <List sx={{ overflow: 'auto', mb: 5 }} >
                                {sidemenuList.map((event, index) => (
                                    <ListItem key={event.menu_name} disablePadding>
                                        {event.menu_status && <NavLink to={event.menu_path} onClick={() => SetHeaderNameAppbar(event.menu_name, event.menu_path)} style={({ isActive, isPending, isTransitioning }) => {
                                            return {
                                                backgroundColor: isActive ? SideDrawerTheme.palette.backgroundColorSelected : "",
                                                color: '#000000',
                                                textDecoration: 'none',
                                                borderRadius: '10px',
                                                width: '90%'
                                            };
                                        }} >
                                            <ListItemButton sx={{ color: SideDrawerTheme.palette.drawerTextColor }} > {event.menu_icon} <ListItemText sx={{ ml: 1 }} primary={event.menu_name} /> </ListItemButton>
                                        </NavLink>}
                                        {!event.menu_status &&
                                            <ListItemButton disabled={true} sx={{ color: SideDrawerTheme.palette.drawerTextColor }} > {event.menu_icon} <ListItemText sx={{ ml: 1 }} primary={event.menu_name} /> </ListItemButton>}
                                    </ListItem>
                                ))}
                            </List>
                            <Box sx={{ position: 'fixed', bottom: 0, backgroundColor: SideDrawerTheme.palette.backgroundColor, borderEndEndRadius: '10px' }} >
                                <Divider width={drawerWidth} />
                                <Box sx={{ display: 'flex', justifyContent: "end" }}>
                                    <Button size="large" onClick={SessionLogout} sx={{ color: SideDrawerTheme.palette.drawerTextColor, textTransform: 'none', mr: 1 }} endIcon={<LogoutIcon />}>Logout</Button>
                                </Box>
                            </Box>
                        </Drawer>
                    </ThemeProvider>
                </Box>
            </ClickAwayListener>
            <Box sx={{ padding: 1.5 }}>
                <DrawerHeader />
                <Outlet />
            </Box>
            <NavFooter />
        </Box>
    );
}

